const copyToClipboard = async (text) => {
  if (!window.isSecureContext || !navigator?.clipboard?.writeText) {
    throw new Error("Clipboard API unavailable in this context");
  }

  await navigator.clipboard.writeText(text);
};

export default copyToClipboard;
